import asyncActionSaga from './asyncActionSaga';

export default asyncActionSaga;